<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/saOMkh/tc-custom/9781426870439.jpg?1700958392738" alt="This image is the cover for the book Because a Husband Is Forever, The Cameo"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Because a Husband Is Forever, The Cameo
      </h1>
      <p class="bookDescription body article font2">
        <p>When talk show host Dakota Delany agrees to allow bodyguard Ian Russell to shadow her for two weeks, she doesn't count on constantly battling the drop-dead-gorgeous man who monitors her every move. And she definitely doesn't expect the strong and silent Ian to immediately take hold of not only her safety, but also her heart.<br/><br/>Strong-willed, feisty Dakota is hardly Ian's ideal client, but she might just be something more -- his perfect match. And it would be more than a ratings triumph if the warring opposites put aside their differences and stopped protecting themselves from their shared fear: true love.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Marie Ferrarella
      </h2>
      
      <p class="authorDescription body article">This USA TODAY bestselling and RITA &reg; Award-winning author has written more than two hundred books for Harlequin Books and Silhouette Books, some under the name Marie Nicole. Her romances are beloved by fans worldwide. Visit her website at www.marieferrarella.com.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?74c77a8d